import { useState, useEffect, useRef } from "react";

// ── Tabler Icons ──────────────────────────────────────────────────────────────
const _tablerLink = document.createElement("link");
_tablerLink.rel = "stylesheet";
_tablerLink.href = "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@2.44.0/tabler-icons.min.css";
document.head.appendChild(_tablerLink);

// ── Google Fonts ─────────────────────────────────────────────────────────────
const _fontLink = document.createElement("link");
_fontLink.rel = "stylesheet";
_fontLink.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap";
document.head.appendChild(_fontLink);

// ── Backend API ───────────────────────────────────────────────────────────────
const API_BASE = "https://api.mysafeghana.com/api";

// ══════════════════════════════════════════════════════════════════════════════
// ADMIN CSS
// ══════════════════════════════════════════════════════════════════════════════
const ADMIN_CSS = `
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'DM Sans',sans-serif;background:#F0F2F5;color:#1a1a2e}
  input,select,textarea{font-family:'DM Sans',sans-serif;border:1.5px solid #e2e8f0;border-radius:8px;padding:9px 12px;font-size:13px;outline:none;background:#fff;color:#1a1a2e;transition:border-color .15s}
  input:focus,select:focus,textarea:focus{border-color:#2563EB;box-shadow:0 0 0 3px rgba(37,99,235,0.12)}
  button{font-family:'DM Sans',sans-serif;cursor:pointer}
  ::-webkit-scrollbar{width:5px;height:5px}
  ::-webkit-scrollbar-track{background:#f1f5f9}
  ::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:10px}
  
  /* Sidebar */
  .adm-sidebar{width:240px;min-height:100vh;background:#0F172A;display:flex;flex-direction:column;flex-shrink:0;position:fixed;top:0;left:0;z-index:100;transition:width .25s}
  .adm-sidebar.collapsed{width:64px}
  .adm-nav-item{display:flex;align-items:center;gap:12px;padding:10px 16px;color:#94A3B8;font-size:13px;font-weight:500;cursor:pointer;border-radius:8px;margin:2px 8px;transition:all .15s;white-space:nowrap;overflow:hidden;text-decoration:none}
  .adm-nav-item:hover{background:rgba(255,255,255,0.06);color:#fff}
  .adm-nav-item.active{background:rgba(37,99,235,0.2);color:#60A5FA;border-left:3px solid #2563EB}
  .adm-nav-item.active i{color:#60A5FA}
  .adm-nav-section{font-size:9px;font-weight:700;color:#475569;letter-spacing:1.5px;text-transform:uppercase;padding:12px 24px 4px;white-space:nowrap;overflow:hidden}
  .adm-sidebar.collapsed .adm-nav-section{opacity:0}
  .adm-sidebar.collapsed .adm-nav-label{display:none}
  
  /* Top bar */
  .adm-topbar{height:60px;background:#fff;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;padding:0 24px;gap:12px;position:sticky;top:0;z-index:90;box-shadow:0 1px 3px rgba(0,0,0,0.06)}
  
  /* Cards */
  .adm-card{background:#fff;border-radius:12px;border:1px solid #e2e8f0;padding:20px;box-shadow:0 1px 3px rgba(0,0,0,0.04)}
  .adm-stat-card{background:#fff;border-radius:12px;border:1px solid #e2e8f0;padding:16px 20px;display:flex;align-items:center;gap:14px;box-shadow:0 1px 3px rgba(0,0,0,0.04);transition:box-shadow .15s}
  .adm-stat-card:hover{box-shadow:0 4px 12px rgba(0,0,0,0.08)}
  
  /* Table */
  .adm-table{width:100%;border-collapse:collapse}
  .adm-table th{padding:10px 14px;text-align:left;font-size:10px;font-weight:700;color:#64748B;text-transform:uppercase;letter-spacing:0.8px;background:#F8FAFC;border-bottom:1px solid #e2e8f0}
  .adm-table td{padding:12px 14px;font-size:13px;border-bottom:1px solid #f1f5f9;vertical-align:middle}
  .adm-table tr:hover td{background:#F8FAFC}
  .adm-table tr:last-child td{border-bottom:none}
  
  /* Badges */
  .badge{display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border-radius:20px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px}
  .badge-critical{background:#F3E8FF;color:#7C3AED}
  .badge-high{background:#FEE2E2;color:#DC2626}
  .badge-medium{background:#FEF3C7;color:#D97706}
  .badge-low{background:#DCFCE7;color:#16A34A}
  .badge-online{background:#DCFCE7;color:#16A34A}
  .badge-offline{background:#FEE2E2;color:#DC2626}
  .badge-maintenance{background:#FEF3C7;color:#D97706}
  .badge-verified{background:#DBEAFE;color:#1D4ED8}
  .badge-pending{background:#FEF9C3;color:#A16207}
  .badge-resolved{background:#F0FDF4;color:#15803D}
  
  /* Buttons */
  .btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;font-size:13px;font-weight:600;border:none;cursor:pointer;transition:all .15s}
  .btn-primary{background:#2563EB;color:#fff;box-shadow:0 2px 4px rgba(37,99,235,0.3)}
  .btn-primary:hover{background:#1D4ED8}
  .btn-danger{background:#DC2626;color:#fff}
  .btn-danger:hover{background:#B91C1C}
  .btn-ghost{background:transparent;color:#64748B;border:1.5px solid #e2e8f0}
  .btn-ghost:hover{background:#F8FAFC;color:#1a1a2e}
  .btn-sm{padding:5px 10px;font-size:11px;border-radius:6px}
  .btn-success{background:#16A34A;color:#fff}
  .btn-success:hover{background:#15803D}
  .btn-warning{background:#D97706;color:#fff}
  
  /* Forms */
  .form-group{margin-bottom:14px}
  .form-label{display:block;font-size:11px;font-weight:600;color:#475569;margin-bottom:5px;text-transform:uppercase;letter-spacing:0.5px}
  
  /* Modal */
  .adm-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1000;display:flex;align-items:center;justify-content:center;padding:16px;backdrop-filter:blur(4px)}
  .adm-modal{background:#fff;border-radius:16px;padding:0;width:100%;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.2);max-height:92vh;overflow-y:auto}
  .adm-modal-header{padding:18px 24px;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;gap:10px;position:sticky;top:0;background:#fff;z-index:1}
  
  /* Animations */
  @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
  .fade-in{animation:fadeIn .2s ease-out}
  @keyframes spin{to{transform:rotate(360deg)}}
  .spin{animation:spin 1s linear infinite}
  
  /* Login */
  .adm-login{min-height:100vh;background:linear-gradient(135deg,#0F172A 0%,#1E293B 50%,#0F172A 100%);display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden}
  .adm-login::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse at 30% 50%,rgba(37,99,235,0.15) 0%,transparent 60%),radial-gradient(ellipse at 70% 20%,rgba(206,17,38,0.1) 0%,transparent 50%)}
  .adm-login-card{background:rgba(255,255,255,0.05);backdrop-filter:blur(20px);border:1px solid rgba(255,255,255,0.1);border-radius:20px;padding:40px;width:100%;max-width:420px;position:relative;z-index:1}
  
  /* Sidebar toggle */
  .adm-content{margin-left:240px;transition:margin-left .25s;min-height:100vh;display:flex;flex-direction:column}
  .adm-content.collapsed{margin-left:64px}
  
  /* Charts placeholder */
  .adm-chart-bar{height:8px;border-radius:4px;background:#e2e8f0;overflow:hidden;flex:1}
  .adm-chart-bar-fill{height:100%;border-radius:4px;transition:width .5s ease}
  
  /* Alert types */
  .alert-row{display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid #f1f5f9}
  .alert-row:last-child{border-bottom:none}
`;

function injectAdminCSS(){
  const el=document.createElement("style");
  el.textContent=ADMIN_CSS;
  document.head.appendChild(el);
}
injectAdminCSS();

// ══════════════════════════════════════════════════════════════════════════════
// SEED DATA
// ══════════════════════════════════════════════════════════════════════════════
const ADMIN_USERS = [
  {id:"a1",name:"Kwame Asante",email:"k.asante@police.gov.gh",role:"Super Admin",tier:"national",region:"all",status:"active",lastLogin:"2025-11-14 09:12",avatar:"KA",phone:"+233244001122"},
  {id:"a2",name:"Ama Mensah",email:"a.mensah@ashanti.gov.gh",role:"Regional Admin",tier:"regional",region:"ashanti",status:"active",lastLogin:"2025-11-14 08:45",avatar:"AM",phone:"+233277334455"},
  {id:"a3",name:"Kofi Boateng",email:"k.boateng@kumasi.gov.gh",role:"District Officer",tier:"district",region:"ashanti",district:"kumasi-metro",status:"active",lastLogin:"2025-11-13 16:30",avatar:"KB",phone:"+233208877665"},
  {id:"a4",name:"Abena Darko",email:"a.darko@accra.gov.gh",role:"District Officer",tier:"district",region:"greater-accra",district:"accra-metro",status:"active",lastLogin:"2025-11-14 07:55",avatar:"AD",phone:"+233243998877"},
  {id:"a5",name:"Yaw Ofori",email:"y.ofori@northern.gov.gh",role:"Regional Admin",tier:"regional",region:"northern",status:"inactive",lastLogin:"2025-11-10 14:20",avatar:"YO",phone:"+233209876543"},
  {id:"a6",name:"Akosua Frimpong",email:"a.frimpong@nadmo.gov.gh",role:"Field Officer",tier:"district",region:"greater-accra",district:"ga-central",status:"active",lastLogin:"2025-11-14 10:01",avatar:"AF",phone:"+233244556677"},
];

const INCIDENT_STATUSES = ["reported","under-investigation","arrested","resolved","closed"];
const SEVERITY_COLORS = {critical:"#7C3AED",high:"#DC2626",medium:"#D97706",low:"#16A34A"};
const SEVERITY_BG = {critical:"#F3E8FF",high:"#FEE2E2",medium:"#FEF3C7",low:"#DCFCE7"};

const SEED_INCIDENTS_ADMIN = [
  {id:1,type:"Armed Robbery",area:"Madina, Accra",region:"greater-accra",severity:"high",status:"under-investigation",date:"2025-11-12",time:"14:30",reporter:"Kofi M.",verified:true,assignedTo:"a4",description:"Armed robbery at Madina Market. 3 suspects fled on motorbike.",ghanaPost:"GA-182-4400",upvotes:23,aiScore:87},
  {id:2,type:"Burglary",area:"Adum, Kumasi",region:"ashanti",severity:"medium",status:"reported",date:"2025-11-08",time:"02:15",reporter:"Ama B.",verified:false,assignedTo:null,description:"Break-in reported at residential property. Cash and electronics stolen.",ghanaPost:"AK-459-2200",upvotes:8,aiScore:72},
  {id:3,type:"Fraud/Cybercrime",area:"Osu, Accra",region:"greater-accra",severity:"medium",status:"under-investigation",date:"2025-11-14",time:"11:00",reporter:"Anonymous",verified:true,assignedTo:"a4",description:"Online fraud targeting mobile money users.",ghanaPost:"GA-144-3300",upvotes:45,aiScore:91},
  {id:4,type:"Drug Trafficking",area:"Takoradi Harbour",region:"western",severity:"high",status:"arrested",date:"2025-10-30",time:"23:45",reporter:"SWAT Unit",verified:true,assignedTo:"a2",description:"Drug trafficking bust at Takoradi port. 2 suspects in custody.",ghanaPost:"WA-211-0040",upvotes:67,aiScore:95},
  {id:5,type:"Road Accident",area:"Accra-Kumasi Highway",region:"ashanti",severity:"high",status:"resolved",date:"2025-11-01",time:"07:20",reporter:"MTTU",verified:true,assignedTo:"a3",description:"Fatal road accident. 2 fatalities, 5 injured.",ghanaPost:"AK-044-7700",upvotes:89,aiScore:88},
  {id:6,type:"Assault",area:"Tema, Greater Accra",region:"greater-accra",severity:"medium",status:"reported",date:"2025-11-13",time:"20:00",reporter:"Victim",verified:false,assignedTo:null,description:"Physical assault reported outside nightclub.",ghanaPost:"GE-044-3300",upvotes:4,aiScore:65},
  {id:7,type:"Kidnapping",area:"East Legon, Accra",region:"greater-accra",severity:"critical",status:"under-investigation",date:"2025-11-14",time:"06:30",reporter:"Family",verified:true,assignedTo:"a1",description:"Child reported missing. Suspected kidnapping. All units alerted.",ghanaPost:"GA-490-2200",upvotes:156,aiScore:98},
  {id:8,type:"Vandalism",area:"Kumasi Central",region:"ashanti",severity:"low",status:"resolved",date:"2025-11-05",time:"22:00",reporter:"Shop Owner",verified:true,assignedTo:"a3",description:"Shop windows smashed. Suspect identified on CCTV.",ghanaPost:"AK-459-1100",upvotes:3,aiScore:55},
  {id:9,type:"Armed Robbery",area:"Lapaz, Accra",region:"greater-accra",severity:"high",status:"reported",date:"2025-11-14",time:"18:00",reporter:"Witness",verified:false,assignedTo:null,description:"Armed robbery at mobile money shop.",ghanaPost:"GN-182-5500",upvotes:12,aiScore:83},
  {id:10,type:"Armed Robbery",area:"Ashaiman",region:"greater-accra",severity:"high",status:"under-investigation",date:"2025-11-13",time:"21:00",reporter:"Anonymous",verified:true,assignedTo:"a4",description:"Three suspects robbed a shop at gunpoint.",ghanaPost:"GE-044-7700",upvotes:34,aiScore:89},
  {id:11,type:"Flood",area:"Odaw River, Accra",region:"greater-accra",severity:"high",status:"reported",date:"2025-11-14",time:"08:00",reporter:"NADMO",verified:true,assignedTo:"a6",description:"Flash flooding reported along Odaw River basin.",ghanaPost:"GA-044-9900",upvotes:78,aiScore:92},
  {id:12,type:"Fraud/Cybercrime",area:"Airport City, Accra",region:"greater-accra",severity:"medium",status:"under-investigation",date:"2025-11-12",time:"14:00",reporter:"Victim",verified:false,assignedTo:null,description:"SIM swap fraud targeting mobile banking customers.",ghanaPost:"GN-044-8800",upvotes:23,aiScore:76},
  {id:13,type:"Burglary",area:"East Legon, Accra",region:"greater-accra",severity:"high",status:"reported",date:"2025-11-14",time:"03:00",reporter:"Neighbour",verified:false,assignedTo:null,description:"Break-in at residential property. Laptop and jewellery stolen.",ghanaPost:"GA-490-6600",upvotes:5,aiScore:71},
];

const AUDIT_LOG = [
  {id:1,user:"Kwame Asante",action:"Verified incident #7 (Kidnapping)",time:"2025-11-14 10:45",ip:"196.216.1.45",severity:"high"},
  {id:2,user:"Ama Mensah",action:"Sent Flash Flood alert to Ashanti Region",time:"2025-11-14 09:30",ip:"197.155.28.12",severity:"medium"},
  {id:3,user:"Kofi Boateng",action:"Assigned incident #5 to Field Officer",time:"2025-11-14 09:15",ip:"154.160.5.22",severity:"low"},
  {id:4,user:"Abena Darko",action:"Updated incident #3 status to Under Investigation",time:"2025-11-14 08:55",ip:"196.216.1.45",severity:"low"},
  {id:5,user:"Kwame Asante",action:"Created new Regional Admin account (Yaw Ofori)",time:"2025-11-13 16:00",ip:"196.216.1.45",severity:"medium"},
  {id:6,user:"Akosua Frimpong",action:"Submitted flood report for Odaw River Basin",time:"2025-11-13 14:22",ip:"154.160.5.99",severity:"low"},
];

const GHANA_REGIONS_ADMIN = [
  {id:"greater-accra",name:"Greater Accra",incidents:6,cameras:5,risk:92},
  {id:"ashanti",name:"Ashanti",incidents:4,cameras:3,risk:85},
  {id:"eastern",name:"Eastern",incidents:1,cameras:1,risk:68},
  {id:"central",name:"Central",incidents:1,cameras:1,risk:62},
  {id:"western",name:"Western",incidents:1,cameras:1,risk:58},
  {id:"northern",name:"Northern",incidents:1,cameras:1,risk:55},
  {id:"volta",name:"Volta",incidents:1,cameras:1,risk:44},
];

// ══════════════════════════════════════════════════════════════════════════════
// MAIN ADMIN APP
// ══════════════════════════════════════════════════════════════════════════════
export default function AdminApp(){
  const [authed, setAuthed]         = useState(false);
  const [authUser, setAuthUser]     = useState(null);
  const [loginForm, setLoginForm]   = useState({email:"",password:"",otp:""});
  const [loginStep, setLoginStep]   = useState(1); // 1=credentials 2=2fa
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [section, setSection]       = useState("dashboard");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [incidents, setIncidents]   = useState([]);
  const [users, setUsers]           = useState([]);
  const [cameras, setCameras]       = useState(ADMIN_CAMERAS); // loaded from API
  const [auditLog, setAuditLog]     = useState(AUDIT_LOG);     // loaded from API
  const [dataLoading, setDataLoading] = useState(true);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertForm, setAlertForm]   = useState({type:"",region:"all",message:"",severity:"high"});
  const [alertSent, setAlertSent]   = useState(false);
  const [incFilter, setIncFilter]   = useState({status:"all",severity:"all",region:"all"});
  const [searchQ, setSearchQ]       = useState("");
  const [newUser, setNewUser]       = useState({name:"",email:"",role:"Field Officer",region:"greater-accra",phone:""});

  // ── Login ──────────────────────────────────────────────────────────────────
  async function handleLogin(){
    setLoginError(""); setLoginLoading(true);
    try{
      const res=await fetch(`${API_BASE}/auth/login`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:loginForm.email,password:loginForm.password}),
      });
      if(res.ok){
        const d=await res.json();
        const u=d.user||d;
        // Store user for OTP step; require admin role
        if(u.role&&["Super Admin","Regional Admin","District Officer","Field Officer"].includes(u.role)){
          setLoginStep(2); setLoginLoading(false);
          // stash user so OTP step can set it
          window._pendingAdminUser=u;
        } else {
          setLoginError("Access denied. Admin accounts only.");setLoginLoading(false);
        }
      } else {
        // Fallback: check seed admin users (for demo)
        const u=ADMIN_USERS.find(u=>u.email===loginForm.email);
        if(!u||loginForm.password.length<4){setLoginError("Invalid email or password.");setLoginLoading(false);return;}
        window._pendingAdminUser=u;
        setLoginStep(2); setLoginLoading(false);
      }
    } catch(e){
      console.warn("Login API error, using local",e);
      const u=ADMIN_USERS.find(u=>u.email===loginForm.email);
      if(!u||loginForm.password.length<4){setLoginError("Invalid email or password.");setLoginLoading(false);return;}
      window._pendingAdminUser=u;
      setLoginStep(2); setLoginLoading(false);
    }
  }
  function handleOTP(){
    setLoginLoading(true);
    setTimeout(()=>{
      if(loginForm.otp.length===6){
        const u=window._pendingAdminUser||ADMIN_USERS.find(u=>u.email===loginForm.email);
        setAuthUser(u); setAuthed(true); setLoginLoading(false);
        delete window._pendingAdminUser;
      } else {setLoginError("Invalid verification code. Use any 6 digits in demo.");setLoginLoading(false);}
    },600);
  }

  // ── Load data from API after login ─────────────────────────────────────────
  useEffect(()=>{
    if(!authed) return;
    async function loadAdminData(){
      setDataLoading(true);
      try{
        const [incRes,userRes,camRes] = await Promise.all([
          fetch(`${API_BASE}/incidents`),
          fetch(`${API_BASE}/users`),
          fetch(`${API_BASE}/cameras`),
        ]);
        if(incRes.ok){
          const d=await incRes.json();
          const rows=d.incidents||d||[];
          if(rows.length>0) setIncidents(rows.map(r=>({
            ...r,
            ghanaPost:r.ghana_post||r.ghanaPost||"",
            assignedTo:r.assigned_to||r.assignedTo||null,
            aiScore:r.ai_score||r.aiScore||0,
            upvotes:r.upvotes||0,
            verified:r.verified||false,
          })));
          else setIncidents(SEED_INCIDENTS_ADMIN);
        } else setIncidents(SEED_INCIDENTS_ADMIN);
      } catch(e){ console.warn("Incidents API error",e); setIncidents(SEED_INCIDENTS_ADMIN); }

      try{
        const userRes=await fetch(`${API_BASE}/users`);
        if(userRes.ok){
          const d=await userRes.json();
          const rows=d.users||d||[];
          if(rows.length>0) setUsers(rows.map(r=>({
            ...r,
            avatar:r.avatar||(r.name?.split(" ").map(w=>w[0]).join("").substring(0,2).toUpperCase()||"?"),
            lastLogin:r.last_login||r.lastLogin||"Never",
            status:r.status||"active",
          })));
          else setUsers(ADMIN_USERS);
        } else setUsers(ADMIN_USERS);
      } catch(e){ console.warn("Users API error",e); setUsers(ADMIN_USERS); }

      try{
        const camRes=await fetch(`${API_BASE}/cameras`);
        if(camRes.ok){
          const d=await camRes.json();
          const rows=d.cameras||d||[];
          if(rows.length>0) setCameras(rows.map(r=>({
            ...r,
            lastPing:r.last_ping||r.lastPing||"Unknown",
            alerts:r.incidents_nearby||r.alerts||0,
          })));
        }
      } catch(e){ console.warn("Cameras API error",e); }

      try{
        const alertsRes=await fetch(`${API_BASE}/alerts`);
        if(alertsRes.ok){
          const d=await alertsRes.json();
          const rows=d.alerts||d||[];
          if(rows.length>0) setAuditLog(rows.map(r=>({
            id:r.id,
            user:r.created_by||r.user||"System",
            action:r.message||r.action||"",
            time:r.created_at||r.time||"",
            severity:r.severity||"low",
            ip:r.ip||"—",
          })));
        }
      } catch(e){ console.warn("Audit/alerts API error",e); }

      setDataLoading(false);
    }
    loadAdminData();
  },[authed]);

  if(!authed) return <LoginPage loginForm={loginForm} setLoginForm={setLoginForm}
    loginStep={loginStep} loginError={loginError} loginLoading={loginLoading}
    handleLogin={handleLogin} handleOTP={handleOTP}/>;

  // ── Filtered incidents ─────────────────────────────────────────────────────
  const filteredInc = incidents.filter(i=>{
    if(incFilter.status!=="all"&&i.status!==incFilter.status)return false;
    if(incFilter.severity!=="all"&&i.severity!==incFilter.severity)return false;
    if(incFilter.region!=="all"&&i.region!==incFilter.region)return false;
    if(searchQ&&!i.type.toLowerCase().includes(searchQ.toLowerCase())&&!i.area.toLowerCase().includes(searchQ.toLowerCase()))return false;
    return true;
  });

  const stats = {
    total: incidents.length,
    critical: incidents.filter(i=>i.severity==="critical").length,
    unverified: incidents.filter(i=>!i.verified).length,
    unassigned: incidents.filter(i=>!i.assignedTo).length,
    resolved: incidents.filter(i=>i.status==="resolved"||i.status==="closed").length,
    highRisk: incidents.filter(i=>["high","critical"].includes(i.severity)).length,
  };

  return(
    <div style={{display:"flex",minHeight:"100vh",background:"#F0F2F5"}}>
      {/* Sidebar */}
      <Sidebar section={section} setSection={setSection} collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed} authUser={authUser} setAuthed={setAuthed}/>

      {/* Main content */}
      <div className={`adm-content${sidebarCollapsed?" collapsed":""}`}>
        {/* Top bar */}
        <div className="adm-topbar">
          <button onClick={()=>setSidebarCollapsed(p=>!p)} style={{background:"none",border:"none",color:"#64748B",fontSize:20,display:"flex",alignItems:"center",padding:4}}>
            <i className="ti ti-menu-2"/>
          </button>
          <div style={{flex:1,fontSize:14,fontWeight:600,color:"#1a1a2e"}}>
            {section==="dashboard"?"Command Dashboard":
             section==="incidents"?"Incident Management":
             section==="alerts"?"Alert Management":
             section==="users"?"User & Role Management":
             section==="cameras"?"Camera Management":
             section==="reports"?"Reports & Analytics":
             section==="audit"?"Audit Log":
             section==="settings"?"System Settings":""}
          </div>
          {/* Stats pills */}
          {stats.critical>0&&<div style={{background:"#FEE2E2",color:"#DC2626",borderRadius:20,padding:"4px 10px",fontSize:11,fontWeight:700,display:"flex",alignItems:"center",gap:4}}>
            <i className="ti ti-alert-triangle" style={{fontSize:12}}/>{stats.critical} Critical
          </div>}
          {stats.unverified>0&&<div style={{background:"#FEF3C7",color:"#D97706",borderRadius:20,padding:"4px 10px",fontSize:11,fontWeight:700,display:"flex",alignItems:"center",gap:4}}>
            <i className="ti ti-clock" style={{fontSize:12}}/>{stats.unverified} Unverified
          </div>}
          <button onClick={()=>setShowAlertModal(true)} className="btn btn-danger" style={{gap:5}}>
            <i className="ti ti-bell-ringing" style={{fontSize:14}}/>Send Alert
          </button>
          <div style={{display:"flex",alignItems:"center",gap:8,marginLeft:8,paddingLeft:12,borderLeft:"1px solid #e2e8f0"}}>
            <div style={{width:32,height:32,borderRadius:"50%",background:"#2563EB",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#fff"}}>{authUser?.avatar}</div>
            <div>
              <div style={{fontSize:12,fontWeight:600,color:"#1a1a2e"}}>{authUser?.name}</div>
              <div style={{fontSize:10,color:"#64748B"}}>{authUser?.role}</div>
            </div>
          </div>
        </div>

        {/* Page content */}
        <div style={{padding:24,flex:1}}>
          {section==="dashboard"&&<Dashboard stats={stats} incidents={incidents} users={users} setSection={setSection} authUser={authUser}/>}
          {section==="incidents"&&<IncidentManagement incidents={incidents} setIncidents={setIncidents} filtered={filteredInc} filter={incFilter} setFilter={setIncFilter} searchQ={searchQ} setSearchQ={setSearchQ} users={users} selected={selectedIncident} setSelected={setSelectedIncident} authUser={authUser}/>}
          {section==="alerts"&&<AlertManagement alertForm={alertForm} setAlertForm={setAlertForm} alertSent={alertSent} setAlertSent={setAlertSent}/>}
          {section==="users"&&<UserManagement users={users} setUsers={setUsers} showModal={showUserModal} setShowModal={setShowUserModal} newUser={newUser} setNewUser={setNewUser} authUser={authUser}/>}
          {section==="cameras"&&<CameraManagement cameras={cameras}/>}
          {section==="reports"&&<ReportsAnalytics incidents={incidents}/>}
          {section==="audit"&&<AuditLog auditLog={auditLog}/>}
          {section==="settings"&&<Settings authUser={authUser}/>}
        </div>
      </div>

      {/* Alert Modal */}
      {showAlertModal&&<AlertModal form={alertForm} setForm={setAlertForm} onClose={()=>setShowAlertModal(false)} onSend={()=>{setAlertSent(true);setShowAlertModal(false);setTimeout(()=>setAlertSent(false),5000);}}/>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// LOGIN PAGE
// ══════════════════════════════════════════════════════════════════════════════
function LoginPage({loginForm,setLoginForm,loginStep,loginError,loginLoading,handleLogin,handleOTP}){
  return(
    <div className="adm-login">
      <div className="adm-login-card">
        {/* Logo */}
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{width:56,height:56,borderRadius:16,background:"linear-gradient(135deg,#CE1126,#8B0000)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",boxShadow:"0 8px 24px rgba(206,17,38,0.4)"}}>
            <i className="ti ti-shield-lock" style={{color:"#fff",fontSize:26}}/>
          </div>
          <div style={{color:"#fff",fontSize:22,fontWeight:700,letterSpacing:-0.5}}>MySafeGhana Admin</div>
          <div style={{color:"#64748B",fontSize:12,marginTop:4}}>Authorised Personnel Only</div>
        </div>

        {loginStep===1?(
          <>
            <div className="form-group">
              <label className="form-label" style={{color:"#94A3B8"}}>Official Email</label>
              <input type="email" value={loginForm.email} onChange={e=>setLoginForm(p=>({...p,email:e.target.value}))}
                placeholder="you@police.gov.gh" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",color:"#fff",borderRadius:10}}
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
            </div>
            <div className="form-group">
              <label className="form-label" style={{color:"#94A3B8"}}>Password</label>
              <input type="password" value={loginForm.password} onChange={e=>setLoginForm(p=>({...p,password:e.target.value}))}
                placeholder="••••••••" style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",color:"#fff",borderRadius:10}}
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
            </div>
            {loginError&&<div style={{background:"rgba(220,38,38,0.15)",border:"1px solid rgba(220,38,38,0.3)",borderRadius:8,padding:"8px 12px",color:"#FCA5A5",fontSize:12,marginBottom:12}}>{loginError}</div>}
            <button onClick={handleLogin} disabled={loginLoading} className="btn btn-primary" style={{width:"100%",justifyContent:"center",padding:12,fontSize:14,borderRadius:10}}>
              {loginLoading?<><i className="ti ti-loader-2 spin" style={{fontSize:16}}/>Verifying...</>:<><i className="ti ti-login" style={{fontSize:16}}/>Sign In</>}
            </button>
            <div style={{marginTop:16,padding:"10px 14px",background:"rgba(37,99,235,0.12)",borderRadius:8,fontSize:11,color:"#93C5FD"}}>
              <strong>Demo:</strong> Use any email from the system (e.g. k.asante@police.gov.gh) and any 4+ char password
            </div>
          </>
        ):(
          <>
            <div style={{textAlign:"center",marginBottom:20}}>
              <div style={{width:48,height:48,borderRadius:"50%",background:"rgba(37,99,235,0.15)",border:"2px solid #2563EB",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 10px"}}>
                <i className="ti ti-device-mobile-message" style={{color:"#60A5FA",fontSize:22}}/>
              </div>
              <div style={{color:"#fff",fontSize:14,fontWeight:600}}>Two-Factor Verification</div>
              <div style={{color:"#64748B",fontSize:11,marginTop:4}}>Enter the 6-digit code sent to your phone</div>
            </div>
            <div className="form-group">
              <input type="text" value={loginForm.otp} onChange={e=>setLoginForm(p=>({...p,otp:e.target.value.replace(/\D/g,"").slice(0,6)}))}
                placeholder="000000" maxLength={6} style={{width:"100%",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",color:"#fff",borderRadius:10,textAlign:"center",fontSize:24,letterSpacing:8,fontFamily:"DM Mono, monospace"}}
                onKeyDown={e=>e.key==="Enter"&&handleOTP()}/>
            </div>
            {loginError&&<div style={{background:"rgba(220,38,38,0.15)",border:"1px solid rgba(220,38,38,0.3)",borderRadius:8,padding:"8px 12px",color:"#FCA5A5",fontSize:12,marginBottom:12}}>{loginError}</div>}
            <button onClick={handleOTP} disabled={loginLoading} className="btn btn-primary" style={{width:"100%",justifyContent:"center",padding:12,fontSize:14,borderRadius:10}}>
              {loginLoading?<><i className="ti ti-loader-2 spin"/>Verifying...</>:<><i className="ti ti-shield-check" style={{fontSize:16}}/>Verify & Access</>}
            </button>
            <div style={{marginTop:16,padding:"10px 14px",background:"rgba(37,99,235,0.12)",borderRadius:8,fontSize:11,color:"#93C5FD"}}>
              <strong>Demo:</strong> Enter any 6 digits (e.g. 123456)
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// SIDEBAR
// ══════════════════════════════════════════════════════════════════════════════
function Sidebar({section,setSection,collapsed,setCollapsed,authUser,setAuthed}){
  const NAV = [
    {section:"core",items:[
      {id:"dashboard",icon:"ti-layout-dashboard",label:"Dashboard"},
    ]},
    {section:"operations",items:[
      {id:"incidents",icon:"ti-alert-triangle",label:"Incidents"},
      {id:"alerts",icon:"ti-bell-ringing",label:"Send Alerts"},
      {id:"cameras",icon:"ti-video",label:"Cameras"},
    ]},
    {section:"admin",items:[
      {id:"users",icon:"ti-users",label:"Users & Roles"},
      {id:"reports",icon:"ti-chart-bar",label:"Analytics"},
      {id:"audit",icon:"ti-clipboard-list",label:"Audit Log"},
      {id:"settings",icon:"ti-settings",label:"Settings"},
    ]},
  ];
  return(
    <div className={`adm-sidebar${collapsed?" collapsed":""}`}>
      {/* Logo */}
      <div style={{padding:"18px 16px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <div style={{width:34,height:34,borderRadius:9,background:"linear-gradient(135deg,#CE1126,#8B0000)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className="ti ti-shield-lock" style={{color:"#fff",fontSize:17}}/>
        </div>
        {!collapsed&&<div>
          <div style={{color:"#fff",fontSize:13,fontWeight:700,lineHeight:1.2}}>MySafeGhana</div>
          <div style={{color:"#475569",fontSize:9,fontWeight:500}}>ADMIN PORTAL</div>
        </div>}
      </div>

      {/* Nav */}
      <div style={{flex:1,overflowY:"auto",padding:"8px 0"}}>
        {NAV.map(group=>(
          <div key={group.section}>
            <div className="adm-nav-section">{group.section.toUpperCase()}</div>
            {group.items.map(item=>(
              <div key={item.id} className={`adm-nav-item${section===item.id?" active":""}`} onClick={()=>setSection(item.id)}>
                <i className={`ti ${item.icon}`} style={{fontSize:18,flexShrink:0}}/>
                <span className="adm-nav-label">{item.label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* User + logout */}
      <div style={{padding:"12px 8px",borderTop:"1px solid rgba(255,255,255,0.06)"}}>
        {!collapsed&&<div style={{padding:"8px 12px",marginBottom:4,borderRadius:8,background:"rgba(255,255,255,0.04)"}}>
          <div style={{color:"#cbd5e1",fontSize:12,fontWeight:600}}>{authUser?.name}</div>
          <div style={{color:"#475569",fontSize:10}}>{authUser?.role}</div>
        </div>}
        <div className="adm-nav-item" onClick={()=>setAuthed(false)}>
          <i className="ti ti-logout" style={{fontSize:18,flexShrink:0}}/>
          <span className="adm-nav-label">Sign Out</span>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// DASHBOARD
// ══════════════════════════════════════════════════════════════════════════════
function Dashboard({stats,incidents,users,setSection,authUser}){
  const recent=incidents.slice(0,5);
  const unverified=incidents.filter(i=>!i.verified);
  const unassigned=incidents.filter(i=>!i.assignedTo);
  
  return(
    <div className="fade-in">
      {/* Welcome */}
      <div style={{marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,color:"#0F172A"}}>
        {(()=>{const h=new Date().getHours();return h<12?"Good morning":h<17?"Good afternoon":"Good evening";})()}, {authUser?.name?.split(" ")[0]} {(()=>{const h=new Date().getHours();return h<12?"🌅":h<17?"☀️":"🌙";})()}
      </div>
          <div style={{fontSize:13,color:"#64748B",marginTop:2}}>Here's what's happening across Ghana today.</div>
        </div>
        <div style={{fontSize:11,color:"#64748B",background:"#fff",padding:"6px 12px",borderRadius:8,border:"1px solid #e2e8f0",display:"flex",alignItems:"center",gap:5}}>
          <i className="ti ti-clock" style={{fontSize:11,color:"#2563EB"}}/>
          {new Date().toLocaleDateString("en-GH",{weekday:"long",year:"numeric",month:"long",day:"numeric"})}
          <span style={{fontFamily:"DM Mono,monospace",color:"#2563EB",fontWeight:600,marginLeft:4}}>
            {new Date().toLocaleTimeString("en-GH",{hour:"2-digit",minute:"2-digit"})}
          </span>
        </div>
      </div>

      {/* Stat cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12,marginBottom:20}}>
        {[
          {label:"Total Incidents",value:stats.total,icon:"ti-list",color:"#2563EB",bg:"#EFF6FF",trend:"+3 today"},
          {label:"Critical",value:stats.critical,icon:"ti-alert-triangle",color:"#7C3AED",bg:"#F5F3FF",trend:"Needs attention"},
          {label:"Unverified",value:stats.unverified,icon:"ti-clock",color:"#D97706",bg:"#FFFBEB",trend:"Pending review"},
          {label:"Unassigned",value:stats.unassigned,icon:"ti-user-x",color:"#DC2626",bg:"#FEF2F2",trend:"Needs officer"},
          {label:"Resolved",value:stats.resolved,icon:"ti-circle-check",color:"#16A34A",bg:"#F0FDF4",trend:"This week"},
          {label:"Active Officers",value:users.filter(u=>u.status==="active").length,icon:"ti-users",color:"#0891B2",bg:"#ECFEFF",trend:"Online now"},
        ].map(s=>(
          <div key={s.label} className="adm-stat-card" style={{cursor:"pointer"}} onClick={()=>s.label!=="Active Officers"&&setSection("incidents")}>
            <div style={{width:44,height:44,borderRadius:12,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${s.icon}`} style={{fontSize:20,color:s.color}}/>
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:24,fontWeight:800,color:"#0F172A",lineHeight:1}}>{s.value}</div>
              <div style={{fontSize:11,color:"#64748B",marginTop:2}}>{s.label}</div>
              <div style={{fontSize:9,color:s.color,marginTop:2,fontWeight:600}}>{s.trend}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        {/* Recent incidents */}
        <div className="adm-card">
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,color:"#0F172A"}}>Recent Incidents</div>
            <button className="btn btn-ghost btn-sm" onClick={()=>setSection("incidents")}>View all →</button>
          </div>
          <table className="adm-table">
            <thead><tr><th>Type</th><th>Area</th><th>Severity</th><th>Status</th></tr></thead>
            <tbody>{recent.map(i=>(
              <tr key={i.id}>
                <td style={{fontWeight:600,fontSize:12}}>{i.type}</td>
                <td style={{color:"#64748B",fontSize:11}}>{i.area}</td>
                <td><span className={`badge badge-${i.severity}`}>{i.severity}</span></td>
                <td><span style={{fontSize:10,color:"#64748B",textTransform:"capitalize"}}>{i.status.replace(/-/g," ")}</span></td>
              </tr>
            ))}</tbody>
          </table>
        </div>

        {/* Action required */}
        <div className="adm-card">
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:14}}>Action Required</div>
          {unverified.length===0&&unassigned.length===0
            ?<div style={{textAlign:"center",padding:"20px 0",color:"#16A34A"}}>
              <i className="ti ti-circle-check" style={{fontSize:32,display:"block",marginBottom:6}}/>
              <div style={{fontSize:12,fontWeight:600}}>All clear!</div>
            </div>
            :<>
              {unverified.slice(0,3).map(i=>(
                <div key={i.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{width:8,height:8,borderRadius:"50%",background:"#D97706",flexShrink:0}}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{i.type}</div>
                    <div style={{fontSize:10,color:"#64748B"}}>{i.area} · Needs verification</div>
                  </div>
                  <span className={`badge badge-${i.severity}`}>{i.severity}</span>
                </div>
              ))}
              {unassigned.slice(0,2).map(i=>(
                <div key={i.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{width:8,height:8,borderRadius:"50%",background:"#DC2626",flexShrink:0}}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{i.type}</div>
                    <div style={{fontSize:10,color:"#64748B"}}>{i.area} · Unassigned</div>
                  </div>
                  <button className="btn btn-ghost btn-sm" onClick={()=>setSection("incidents")}>Assign</button>
                </div>
              ))}
            </>
          }
        </div>
      </div>

      {/* Regional overview */}
      <div className="adm-card">
        <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:14}}>Regional Overview</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
          {GHANA_REGIONS_ADMIN.map(r=>(
            <div key={r.id} style={{background:"#F8FAFC",borderRadius:10,padding:"12px 14px",border:"1px solid #e2e8f0"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{r.name}</div>
                <div style={{fontSize:11,fontWeight:700,color:r.risk>80?"#DC2626":r.risk>60?"#D97706":"#16A34A"}}>{r.risk}</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                <div className="adm-chart-bar"><div className="adm-chart-bar-fill" style={{width:r.risk+"%",background:r.risk>80?"#DC2626":r.risk>60?"#D97706":"#16A34A"}}/></div>
              </div>
              <div style={{display:"flex",gap:10}}>
                <span style={{fontSize:10,color:"#64748B"}}><i className="ti ti-alert-triangle" style={{fontSize:10}}/> {r.incidents} incidents</span>
                <span style={{fontSize:10,color:"#64748B"}}><i className="ti ti-video" style={{fontSize:10}}/> {r.cameras} cameras</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// INCIDENT MANAGEMENT
// ══════════════════════════════════════════════════════════════════════════════
function IncidentManagement({incidents,setIncidents,filtered,filter,setFilter,searchQ,setSearchQ,users,selected,setSelected,authUser}){
  async function verifyIncident(id){
    setIncidents(p=>p.map(i=>i.id===id?{...i,verified:true}:i));
    try{ await fetch(`${API_BASE}/incidents/${id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({verified:true})}); }
    catch(e){ console.warn("Verify API error",e); }
  }
  async function resolveIncident(id){
    setIncidents(p=>p.map(i=>i.id===id?{...i,status:"resolved"}:i));
    try{ await fetch(`${API_BASE}/incidents/${id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({status:"resolved"})}); }
    catch(e){ console.warn("Resolve API error",e); }
  }
  async function assignIncident(id,uid){
    setIncidents(p=>p.map(i=>i.id===id?{...i,assignedTo:uid}:i));
    try{ await fetch(`${API_BASE}/incidents/${id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({assigned_to:uid})}); }
    catch(e){ console.warn("Assign API error",e); }
  }

  return(
    <div className="fade-in">
      {/* Filters */}
      <div className="adm-card" style={{marginBottom:16}}>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{position:"relative",flex:"1 1 200px"}}>
            <i className="ti ti-search" style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:14,color:"#94A3B8"}}/>
            <input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Search incidents..." style={{width:"100%",paddingLeft:32}}/>
          </div>
          {[
            {key:"status",opts:["all","reported","under-investigation","arrested","resolved","closed"]},
            {key:"severity",opts:["all","critical","high","medium","low"]},
            {key:"region",opts:["all","greater-accra","ashanti","eastern","central","western","northern","volta"]},
          ].map(f=>(
            <select key={f.key} value={filter[f.key]} onChange={e=>setFilter(p=>({...p,[f.key]:e.target.value}))} style={{flex:"0 0 auto"}}>
              {f.opts.map(o=><option key={o} value={o}>{o==="all"?"All "+f.key.charAt(0).toUpperCase()+f.key.slice(1):o.replace(/-/g," ")}</option>)}
            </select>
          ))}
          <div style={{fontSize:12,color:"#64748B",marginLeft:"auto"}}>{filtered.length} incidents</div>
        </div>
      </div>

      {/* Table */}
      <div className="adm-card" style={{padding:0,overflow:"hidden"}}>
        <table className="adm-table">
          <thead><tr>
            <th>ID</th><th>Type</th><th>Area</th><th>Severity</th>
            <th>Status</th><th>Verified</th><th>Assigned</th><th>Date</th><th>Actions</th>
          </tr></thead>
          <tbody>{filtered.map(inc=>(
            <tr key={inc.id} style={{cursor:"pointer"}} onClick={()=>setSelected(inc)}>
              <td style={{fontFamily:"DM Mono,monospace",fontSize:11,color:"#94A3B8"}}>#{inc.id}</td>
              <td style={{fontWeight:600,fontSize:12}}>{inc.type}</td>
              <td style={{fontSize:11,color:"#64748B"}}>{inc.area}</td>
              <td><span className={`badge badge-${inc.severity}`}>{inc.severity}</span></td>
              <td><span style={{fontSize:10,background:"#F1F5F9",color:"#475569",padding:"2px 7px",borderRadius:10,textTransform:"capitalize"}}>{inc.status.replace(/-/g," ")}</span></td>
              <td onClick={e=>e.stopPropagation()}>
                {inc.verified
                  ?<span style={{color:"#16A34A",fontSize:11,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-circle-check" style={{fontSize:13}}/>Verified</span>
                  :<button className="btn btn-ghost btn-sm" onClick={()=>verifyIncident(inc.id)}>Verify</button>}
              </td>
              <td style={{fontSize:11}}>
                {inc.assignedTo
                  ?users.find(u=>u.id===inc.assignedTo)?.name||"Unknown"
                  :<select onClick={e=>e.stopPropagation()} onChange={e=>assignIncident(inc.id,e.target.value)} style={{fontSize:11,padding:"3px 6px"}}>
                    <option value="">Assign...</option>
                    {users.filter(u=>u.status==="active").map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>}
              </td>
              <td style={{fontSize:11,color:"#94A3B8"}}>{inc.date}</td>
              <td onClick={e=>e.stopPropagation()} style={{display:"flex",gap:4}}>
                <button className="btn btn-ghost btn-sm" onClick={()=>setSelected(inc)}>
                  <i className="ti ti-eye" style={{fontSize:12}}/>View
                </button>
                {inc.status!=="resolved"&&<button className="btn btn-success btn-sm" onClick={()=>resolveIncident(inc.id)}>
                  <i className="ti ti-check" style={{fontSize:12}}/>Resolve
                </button>}
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>

      {/* Incident detail modal */}
      {selected&&<div className="adm-modal-overlay" onClick={()=>setSelected(null)}>
        <div className="adm-modal" style={{maxWidth:560}} onClick={e=>e.stopPropagation()}>
          <div className="adm-modal-header">
            <span className={`badge badge-${selected.severity}`}>{selected.severity.toUpperCase()}</span>
            <div style={{flex:1}}>
              <div style={{fontSize:15,fontWeight:700}}>{selected.type}</div>
              <div style={{fontSize:11,color:"#64748B"}}>{selected.area} · {selected.date} {selected.time}</div>
            </div>
            <button onClick={()=>setSelected(null)} style={{background:"none",border:"none",fontSize:20,color:"#94A3B8",cursor:"pointer"}}><i className="ti ti-x"/></button>
          </div>
          <div style={{padding:20}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
              {[["Ghana Post",selected.ghanaPost],["Reporter",selected.reporter],["Status",selected.status.replace(/-/g," ")],["AI Score",selected.aiScore+"%"],["Assigned To",users.find(u=>u.id===selected.assignedTo)?.name||"Unassigned"],["Upvotes",selected.upvotes+" community reports"]].map(([l,v])=>(
                <div key={l} style={{background:"#F8FAFC",borderRadius:8,padding:"8px 12px"}}>
                  <div style={{fontSize:9,color:"#94A3B8",fontWeight:700,textTransform:"uppercase",letterSpacing:0.5,marginBottom:3}}>{l}</div>
                  <div style={{fontSize:12,fontWeight:600,color:"#0F172A",textTransform:"capitalize"}}>{v}</div>
                </div>
              ))}
            </div>
            <div style={{background:"#F8FAFC",borderRadius:8,padding:"10px 12px",marginBottom:14}}>
              <div style={{fontSize:9,color:"#94A3B8",fontWeight:700,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Description</div>
              <div style={{fontSize:12,color:"#475569",lineHeight:1.6}}>{selected.description}</div>
            </div>
            <div style={{display:"flex",gap:8}}>
              {!selected.verified&&<button className="btn btn-warning" onClick={()=>{verifyIncident(selected.id);setSelected(p=>({...p,verified:true}));}}>
                <i className="ti ti-shield-check" style={{fontSize:14}}/>Verify Report
              </button>}
              {selected.status!=="resolved"&&<button className="btn btn-success" onClick={()=>{resolveIncident(selected.id);setSelected(p=>({...p,status:"resolved"}));}}>
                <i className="ti ti-check" style={{fontSize:14}}/>Mark Resolved
              </button>}
              <button className="btn btn-ghost" onClick={()=>setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// ALERT MANAGEMENT
// ══════════════════════════════════════════════════════════════════════════════
const ALERT_TYPES_ADMIN = [
  {id:"heavy-rain",label:"Heavy Rainfall",icon:"ti-cloud-rain",severity:"high"},
  {id:"flash-flood",label:"Flash Flood",icon:"ti-waves",severity:"critical"},
  {id:"armed-robbery",label:"Armed Robbery Alert",icon:"ti-alert-triangle",severity:"critical"},
  {id:"kidnapping",label:"Kidnapping Alert",icon:"ti-user-exclamation",severity:"critical"},
  {id:"road-closure",label:"Road Closure",icon:"ti-road-off",severity:"medium"},
  {id:"power-outage",label:"Power Outage",icon:"ti-plug-off",severity:"low"},
  {id:"disease-outbreak",label:"Disease Outbreak",icon:"ti-virus",severity:"high"},
  {id:"missing-person",label:"Missing Person",icon:"ti-user-search",severity:"high"},
  {id:"wildfire",label:"Wildfire Warning",icon:"ti-flame",severity:"high"},
  {id:"extreme-heat",label:"Extreme Heat",icon:"ti-sun-high",severity:"medium"},
];

function AlertManagement({alertForm,setAlertForm,alertSent,setAlertSent}){
  const [sending,setSending]=useState(false);
  function sendAlert(){
    if(!alertForm.type||!alertForm.message)return;
    setSending(true);
    setTimeout(()=>{setSending(false);setAlertSent(true);setAlertForm({type:"",region:"all",message:"",severity:"high"});},1500);
  }
  return(
    <div className="fade-in" style={{maxWidth:700}}>
      {alertSent&&<div style={{background:"#F0FDF4",border:"1.5px solid #86EFAC",borderRadius:10,padding:"12px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
        <i className="ti ti-circle-check" style={{fontSize:20,color:"#16A34A"}}/>
        <div><div style={{fontSize:13,fontWeight:600,color:"#15803D"}}>Alert sent successfully!</div>
        <div style={{fontSize:11,color:"#166534"}}>Notification dispatched to all registered citizens in the selected area.</div></div>
      </div>}
      <div className="adm-card">
        <div style={{fontSize:15,fontWeight:700,color:"#0F172A",marginBottom:16,display:"flex",alignItems:"center",gap:8}}>
          <i className="ti ti-bell-ringing" style={{fontSize:18,color:"#DC2626"}}/>Send Public Safety Alert
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
          <div className="form-group" style={{marginBottom:0}}>
            <label className="form-label">Alert Type *</label>
            <select value={alertForm.type} onChange={e=>{const t=ALERT_TYPES_ADMIN.find(a=>a.id===e.target.value);setAlertForm(p=>({...p,type:e.target.value,severity:t?.severity||"high"}));}} style={{width:"100%"}}>
              <option value="">Select alert type...</option>
              {ALERT_TYPES_ADMIN.map(a=><option key={a.id} value={a.id}>{a.label}</option>)}
            </select>
          </div>
          <div className="form-group" style={{marginBottom:0}}>
            <label className="form-label">Target Region</label>
            <select value={alertForm.region} onChange={e=>setAlertForm(p=>({...p,region:e.target.value}))} style={{width:"100%"}}>
              <option value="all">All Ghana (National)</option>
              {GHANA_REGIONS_ADMIN.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Severity</label>
          <div style={{display:"flex",gap:8}}>
            {["low","medium","high","critical"].map(s=>(
              <button key={s} onClick={()=>setAlertForm(p=>({...p,severity:s}))}
                className={`btn btn-sm`} style={{flex:1,justifyContent:"center",
                  background:alertForm.severity===s?SEVERITY_COLORS[s]:SEVERITY_BG[s],
                  color:alertForm.severity===s?"#fff":SEVERITY_COLORS[s],
                  border:`1.5px solid ${SEVERITY_COLORS[s]}44`}}>
                {s.charAt(0).toUpperCase()+s.slice(1)}
              </button>
            ))}
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Alert Message *</label>
          <textarea value={alertForm.message} onChange={e=>setAlertForm(p=>({...p,message:e.target.value}))}
            placeholder="Enter the alert message that will be sent to citizens..."
            rows={4} style={{width:"100%",resize:"vertical"}}/>
        </div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <button onClick={sendAlert} disabled={sending||!alertForm.type||!alertForm.message} className="btn btn-danger" style={{gap:6}}>
            {sending?<><i className="ti ti-loader-2 spin" style={{fontSize:15}}/>Sending...</>:<><i className="ti ti-send" style={{fontSize:15}}/>Broadcast Alert</>}
          </button>
          <div style={{fontSize:11,color:"#94A3B8"}}>
            Will notify all citizens in {alertForm.region==="all"?"Ghana (all 16 regions)":GHANA_REGIONS_ADMIN.find(r=>r.id===alertForm.region)?.name+" Region"}
          </div>
        </div>
      </div>

      {/* Recent alerts */}
      <div className="adm-card" style={{marginTop:16}}>
        <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:14}}>Recent Alerts Sent</div>
        {[
          {type:"Flash Flood",region:"Greater Accra",by:"Kwame Asante",time:"2025-11-14 09:30",severity:"critical"},
          {type:"Armed Robbery Alert",region:"Ashanti",by:"Ama Mensah",time:"2025-11-13 21:15",severity:"critical"},
          {type:"Road Closure",region:"Eastern",by:"Kofi Boateng",time:"2025-11-13 14:00",severity:"medium"},
          {type:"Heavy Rainfall",region:"All Ghana",by:"Kwame Asante",time:"2025-11-12 07:00",severity:"high"},
        ].map((a,i)=>(
          <div key={i} className="alert-row">
            <span className={`badge badge-${a.severity}`}>{a.severity}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{a.type}</div>
              <div style={{fontSize:10,color:"#64748B"}}>{a.region} · Sent by {a.by}</div>
            </div>
            <div style={{fontSize:10,color:"#94A3B8",fontFamily:"DM Mono,monospace"}}>{a.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// USER MANAGEMENT
// ══════════════════════════════════════════════════════════════════════════════
function UserManagement({users,setUsers,showModal,setShowModal,newUser,setNewUser,authUser}){
  const [userSearch,setUserSearch]=useState("");
  const filteredUsers=userSearch?users.filter(u=>
    u.name.toLowerCase().includes(userSearch.toLowerCase())||
    u.email.toLowerCase().includes(userSearch.toLowerCase())||
    u.role.toLowerCase().includes(userSearch.toLowerCase())||
    u.region.toLowerCase().includes(userSearch.toLowerCase())
  ):users;
  async function addUser(){
    if(!newUser.name||!newUser.email)return;
    const u={id:"a"+Date.now(),name:newUser.name,email:newUser.email,role:newUser.role,tier:newUser.role==="Super Admin"?"national":newUser.role==="Regional Admin"?"regional":"district",region:newUser.region,status:"active",lastLogin:"Never",avatar:newUser.name.split(" ").map(w=>w[0]).join("").substring(0,2).toUpperCase(),phone:newUser.phone};
    setUsers(p=>[...p,u]);
    setShowModal(false);setNewUser({name:"",email:"",role:"Field Officer",region:"greater-accra",phone:""});
    try{ await fetch(`${API_BASE}/users`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({name:u.name,email:u.email,role:u.role,region:u.region,phone:u.phone,password:"Ghana@123"})}); }
    catch(e){ console.warn("Add user API error",e); }
  }
  async function toggleStatus(id){
    const newStatus=users.find(u=>u.id===id)?.status==="active"?"inactive":"active";
    setUsers(p=>p.map(u=>u.id===id?{...u,status:newStatus}:u));
    try{ await fetch(`${API_BASE}/users/${id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({status:newStatus})}); }
    catch(e){ console.warn("Toggle status API error",e); }
  }
  
  return(
    <div className="fade-in">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,gap:10,flexWrap:"wrap"}}>
        <div style={{position:"relative",flex:"1 1 220px"}}>
          <i className="ti ti-search" style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:14,color:"#94A3B8",pointerEvents:"none"}}/>
          <input placeholder="Search officers by name, email or role..."
            onChange={e=>{setUserSearch(e.target.value);}}
            style={{width:"100%",paddingLeft:32}}/>
        </div>
        <div style={{fontSize:13,color:"#64748B",flexShrink:0}}>{users.length} officers registered</div>
        <button className="btn btn-primary" onClick={()=>setShowModal(true)}>
          <i className="ti ti-user-plus" style={{fontSize:14}}/>Add Officer
        </button>
      </div>
      
      {/* Role tier breakdown */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
        {[
          {tier:"national",label:"National",icon:"ti-building-community",color:"#7C3AED",desc:"Full Ghana access"},
          {tier:"regional",label:"Regional",icon:"ti-map-2",color:"#2563EB",desc:"16 regions"},
          {tier:"district",label:"District",icon:"ti-map-pin",color:"#0891B2",desc:"260 assemblies"},
        ].map(t=>(
          <div key={t.tier} className="adm-stat-card">
            <div style={{width:40,height:40,borderRadius:10,background:t.color+"15",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${t.icon}`} style={{fontSize:18,color:t.color}}/>
            </div>
            <div>
              <div style={{fontSize:20,fontWeight:800,color:"#0F172A"}}>{users.filter(u=>u.tier===t.tier).length}</div>
              <div style={{fontSize:11,color:"#64748B"}}>{t.label} Officers</div>
              <div style={{fontSize:9,color:t.color,fontWeight:600}}>{t.desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="adm-card" style={{padding:0,overflow:"hidden"}}>
        <table className="adm-table">
          <thead><tr><th>Officer</th><th>Role</th><th>Tier</th><th>Region</th><th>Status</th><th>Last Login</th><th>Actions</th></tr></thead>
          <tbody>{filteredUsers.map(u=>(
            <tr key={u.id}>
              <td>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:30,height:30,borderRadius:"50%",background:"#EFF6FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#2563EB",flexShrink:0}}>{u.avatar}</div>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{u.name}</div>
                    <div style={{fontSize:10,color:"#94A3B8"}}>{u.email}</div>
                  </div>
                </div>
              </td>
              <td style={{fontSize:11}}>{u.role}</td>
              <td><span style={{fontSize:9,background:"#F1F5F9",color:"#475569",padding:"2px 8px",borderRadius:10,fontWeight:600,textTransform:"capitalize"}}>{u.tier}</span></td>
              <td style={{fontSize:11,color:"#64748B",textTransform:"capitalize"}}>{u.region.replace(/-/g," ")}</td>
              <td><span className={`badge badge-${u.status==="active"?"online":"offline"}`}>{u.status}</span></td>
              <td style={{fontSize:10,color:"#94A3B8",fontFamily:"DM Mono,monospace"}}>{u.lastLogin}</td>
              <td>
                <div style={{display:"flex",gap:4}}>
                  <button className="btn btn-ghost btn-sm" onClick={()=>toggleStatus(u.id)}>
                    {u.status==="active"?"Suspend":"Activate"}
                  </button>
                </div>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>

      {showModal&&<div className="adm-modal-overlay" onClick={()=>setShowModal(false)}>
        <div className="adm-modal" style={{maxWidth:480}} onClick={e=>e.stopPropagation()}>
          <div className="adm-modal-header">
            <i className="ti ti-user-plus" style={{fontSize:18,color:"#2563EB"}}/>
            <div style={{fontSize:15,fontWeight:700}}>Add New Officer</div>
            <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",fontSize:20,color:"#94A3B8",cursor:"pointer",marginLeft:"auto"}}><i className="ti ti-x"/></button>
          </div>
          <div style={{padding:20}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {[["Full Name","name","text","e.g. Kofi Mensah"],["Email","email","email","officer@police.gov.gh"],["Phone","phone","tel","+233244123456"]].map(([l,k,t,ph])=>(
                <div key={k} className="form-group" style={{marginBottom:0,gridColumn:k==="email"?"1 / -1":"auto"}}>
                  <label className="form-label">{l}</label>
                  <input type={t} value={newUser[k]} onChange={e=>setNewUser(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%"}}/>
                </div>
              ))}
              <div className="form-group" style={{marginBottom:0}}>
                <label className="form-label">Role</label>
                <select value={newUser.role} onChange={e=>setNewUser(p=>({...p,role:e.target.value}))} style={{width:"100%"}}>
                  {["Field Officer","District Officer","Regional Admin","Super Admin"].map(r=><option key={r}>{r}</option>)}
                </select>
              </div>
              <div className="form-group" style={{marginBottom:0}}>
                <label className="form-label">Region</label>
                <select value={newUser.region} onChange={e=>setNewUser(p=>({...p,region:e.target.value}))} style={{width:"100%"}}>
                  {GHANA_REGIONS_ADMIN.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginTop:16}}>
              <button onClick={addUser} className="btn btn-primary">
                <i className="ti ti-user-plus" style={{fontSize:14}}/>Add Officer
              </button>
              <button onClick={()=>setShowModal(false)} className="btn btn-ghost">Cancel</button>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// CAMERA MANAGEMENT
// ══════════════════════════════════════════════════════════════════════════════
const ADMIN_CAMERAS = [
  {id:"cam-001",name:"Kwame Nkrumah Circle",area:"Accra Central",status:"online",resolution:"1080p",lastPing:"2 mins ago",alerts:3},
  {id:"cam-002",name:"Osu Oxford Street",area:"Osu",status:"online",resolution:"4K",lastPing:"1 min ago",alerts:2},
  {id:"cam-003",name:"Tema Harbour Gate 1",area:"Tema",status:"online",resolution:"1080p",lastPing:"3 mins ago",alerts:0},
  {id:"cam-004",name:"Madina Market",area:"Madina",status:"offline",resolution:"720p",lastPing:"3 hours ago",alerts:0},
  {id:"cam-006",name:"Kejetia Market",area:"Kumasi",status:"online",resolution:"1080p",lastPing:"1 min ago",alerts:1},
  {id:"cam-008",name:"Suame Magazine",area:"Kumasi",status:"maintenance",resolution:"1080p",lastPing:"45 mins ago",alerts:0},
];
function CameraManagement({cameras=ADMIN_CAMERAS}){
  const [filter,setFilter]=useState("all");
  const vis=filter==="all"?cameras:cameras.filter(c=>c.status===filter);
  return(
    <div className="fade-in">
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
        {[{l:"Online",v:cameras.filter(c=>c.status==="online").length,c:"#16A34A",i:"ti-circle-check"},
          {l:"Offline",v:cameras.filter(c=>c.status==="offline").length,c:"#DC2626",i:"ti-circle-x"},
          {l:"Maintenance",v:cameras.filter(c=>c.status==="maintenance").length,c:"#D97706",i:"ti-tool"}].map(s=>(
          <div key={s.l} className="adm-stat-card" style={{cursor:"pointer"}} onClick={()=>setFilter(s.l.toLowerCase())}>
            <div style={{width:40,height:40,borderRadius:10,background:s.c+"15",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${s.i}`} style={{fontSize:20,color:s.c}}/>
            </div>
            <div><div style={{fontSize:22,fontWeight:800,color:"#0F172A"}}>{s.v}</div>
            <div style={{fontSize:11,color:"#64748B"}}>{s.l} Cameras</div></div>
          </div>
        ))}
      </div>
      <div className="adm-card" style={{padding:0,overflow:"hidden"}}>
        <table className="adm-table">
          <thead><tr><th>Camera</th><th>Area</th><th>Status</th><th>Resolution</th><th>Last Ping</th><th>Alerts</th><th>Actions</th></tr></thead>
          <tbody>{vis.map(c=>(
            <tr key={c.id}>
              <td>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:30,height:30,borderRadius:8,background:c.status==="online"?"#DCFCE7":c.status==="offline"?"#FEE2E2":"#FEF3C7",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <i className="ti ti-video" style={{fontSize:14,color:c.status==="online"?"#16A34A":c.status==="offline"?"#DC2626":"#D97706"}}/>
                  </div>
                  <div style={{fontSize:12,fontWeight:600}}>{c.name}</div>
                </div>
              </td>
              <td style={{fontSize:11,color:"#64748B"}}>{c.area}</td>
              <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
              <td style={{fontSize:11,fontFamily:"DM Mono,monospace"}}>{c.resolution}</td>
              <td style={{fontSize:11,color:"#94A3B8"}}>{c.lastPing}</td>
              <td>{c.alerts>0?<span style={{background:"#FEE2E2",color:"#DC2626",borderRadius:20,padding:"2px 8px",fontSize:10,fontWeight:700}}>{c.alerts} alerts</span>:<span style={{color:"#94A3B8",fontSize:11}}>None</span>}</td>
              <td style={{display:"flex",gap:4}}>
                <button className="btn btn-ghost btn-sm" onClick={()=>{
                  const w=window.open("","_blank","width=640,height=400");
                  w.document.write(`<html><body style="margin:0;background:#000"><canvas id="feed" width="640" height="360" style="width:100%"></canvas><script>
                    const cv=document.getElementById('feed'),ctx=cv.getContext('2d');
                    const cars=Array.from({length:6},()=>({x:Math.random()*640,y:100+Math.random()*200,speed:1+Math.random()*2,color:'#'+Math.floor(Math.random()*0xffffff).toString(16).padStart(6,'0')}));
                    function draw(){ctx.fillStyle='#1a1a1a';ctx.fillRect(0,0,640,360);ctx.fillStyle='#333';ctx.fillRect(0,180,640,3);ctx.fillStyle='#555';for(let i=0;i<640;i+=40)ctx.fillRect(i,178,20,7);cars.forEach(c=>{c.x=(c.x+c.speed)%660;ctx.fillStyle=c.color;ctx.fillRect(c.x,c.y,30,16);});ctx.fillStyle='rgba(0,255,0,0.8)';ctx.font='11px monospace';ctx.fillText('${c.name} | LIVE | '+new Date().toLocaleTimeString(),10,20);ctx.fillStyle='red';ctx.beginPath();ctx.arc(620,15,6,0,Math.PI*2);ctx.fill();requestAnimationFrame(draw);}draw();
                  <\/script></body></html>`);
                }}><i className="ti ti-player-play" style={{fontSize:12}}/>View Feed</button>
                <button className="btn btn-ghost btn-sm" onClick={()=>{const txt=["Camera: "+c.name,"Status: "+c.status,"Resolution: "+c.resolution,"Exported: "+new Date().toISOString()].join("\n");const a=document.createElement("a");a.href="data:text/plain,"+encodeURIComponent(txt);a.download=c.id+"_log.txt";a.click();}}><i className="ti ti-download" style={{fontSize:12}}/>Export Log</button>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// REPORTS & ANALYTICS
// ══════════════════════════════════════════════════════════════════════════════
function ReportsAnalytics({incidents}){
  const byType={};incidents.forEach(i=>{byType[i.type]=(byType[i.type]||0)+1;});
  const bySev={critical:0,high:0,medium:0,low:0};incidents.forEach(i=>{bySev[i.severity]++;});
  const maxType=Math.max(...Object.values(byType),1); // prevent division by zero
  return(
    <div className="fade-in">
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        <div className="adm-card">
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:14}}>Incidents by Type</div>
          {Object.entries(byType).sort((a,b)=>b[1]-a[1]).map(([type,count])=>(
            <div key={type} style={{marginBottom:10}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                <span style={{color:"#475569",fontWeight:500}}>{type}</span>
                <span style={{fontWeight:700,color:"#DC2626"}}>{count}</span>
              </div>
              <div className="adm-chart-bar"><div className="adm-chart-bar-fill" style={{width:Math.max(8,(count/maxType*100))+"%",background:"#2563EB",minWidth:"8px"}}/></div>
            </div>
          ))}
        </div>
        <div className="adm-card">
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:14}}>Severity Distribution</div>
          {Object.entries(bySev).map(([s,c])=>(
            <div key={s} style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
              <span className={`badge badge-${s}`} style={{minWidth:60,justifyContent:"center"}}>{s}</span>
              <div className="adm-chart-bar"><div className="adm-chart-bar-fill" style={{width:(c/incidents.length*100)+"%",background:SEVERITY_COLORS[s]}}/></div>
              <span style={{fontSize:12,fontWeight:700,minWidth:20}}>{c}</span>
            </div>
          ))}
          <div style={{marginTop:14,padding:"10px 12px",background:"#F8FAFC",borderRadius:8,display:"flex",gap:16}}>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:20,fontWeight:800,color:"#0F172A"}}>{incidents.filter(i=>i.verified).length}</div>
              <div style={{fontSize:10,color:"#64748B"}}>Verified</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:20,fontWeight:800,color:"#0F172A"}}>{incidents.filter(i=>i.status==="resolved").length}</div>
              <div style={{fontSize:10,color:"#64748B"}}>Resolved</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:20,fontWeight:800,color:"#0F172A"}}>{Math.round(incidents.filter(i=>i.verified).length/incidents.length*100)}%</div>
              <div style={{fontSize:10,color:"#64748B"}}>Verify Rate</div>
            </div>
          </div>
        </div>
      </div>
      <div className="adm-card">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A"}}>Export Reports</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:10}}>
          {[["Incident Summary","PDF","ti-file-type-pdf","#DC2626"],["Monthly Report","Excel","ti-file-spreadsheet","#16A34A"],["Camera Log","CSV","ti-file-text","#2563EB"],["Audit Report","PDF","ti-clipboard-list","#7C3AED"]].map(([l,fmt,icon,c])=>(
            <button key={l} className="btn btn-ghost" style={{flexDirection:"column",height:80,gap:6,borderRadius:10,border:"1.5px dashed #e2e8f0"}}>
              <i className={`ti ${icon}`} style={{fontSize:22,color:c}}/>
              <span style={{fontSize:11}}>{l}</span>
              <span style={{fontSize:9,color:"#94A3B8"}}>{fmt} Export</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// AUDIT LOG
// ══════════════════════════════════════════════════════════════════════════════
function AuditLog({auditLog=AUDIT_LOG}){
  return(
    <div className="fade-in">
      <div className="adm-card" style={{padding:0,overflow:"hidden"}}>
        <div style={{padding:"14px 20px",borderBottom:"1px solid #e2e8f0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:14,fontWeight:700,color:"#0F172A"}}>System Activity Log</div>
          <button className="btn btn-ghost btn-sm"><i className="ti ti-download" style={{fontSize:12}}/>Export Log</button>
        </div>
        <table className="adm-table">
          <thead><tr><th>#</th><th>Officer</th><th>Action</th><th>IP Address</th><th>Severity</th><th>Timestamp</th></tr></thead>
          <tbody>{auditLog.map(log=>(
            <tr key={log.id}>
              <td style={{fontFamily:"DM Mono,monospace",fontSize:10,color:"#94A3B8"}}>#{log.id}</td>
              <td style={{fontSize:12,fontWeight:600,color:"#0F172A"}}>{log.user}</td>
              <td style={{fontSize:12,color:"#475569"}}>{log.action}</td>
              <td style={{fontSize:10,fontFamily:"DM Mono,monospace",color:"#94A3B8"}}>{log.ip}</td>
              <td><span className={`badge badge-${log.severity}`}>{log.severity}</span></td>
              <td style={{fontSize:10,color:"#94A3B8",fontFamily:"DM Mono,monospace"}}>{log.time}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// SETTINGS
// ══════════════════════════════════════════════════════════════════════════════
function Settings({authUser}){
  return(
    <div className="fade-in" style={{maxWidth:600}}>
      <div className="adm-card" style={{marginBottom:16}}>
        <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:16}}>Profile Settings</div>
        {[["Full Name",authUser?.name],["Email",(authUser?.email||"").toLowerCase()],["Phone",authUser?.phone||"+233 — —"],["Role",authUser?.role],["Region Access",authUser?.region==="all"?"All Ghana (National)":(authUser?.region||"").replace(/-/g," ")]].map(([l,v])=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid #f1f5f9"}}>
            <div style={{fontSize:11,fontWeight:600,color:"#94A3B8",minWidth:100,textTransform:"uppercase",letterSpacing:0.5}}>{l}</div>
            <div style={{fontSize:13,color:"#0F172A",flex:1,textTransform:"capitalize"}}>{v}</div>
            <button className="btn btn-ghost btn-sm">Edit</button>
          </div>
        ))}
      </div>
      <div className="adm-card">
        <div style={{fontSize:14,fontWeight:700,color:"#0F172A",marginBottom:16}}>Security</div>
        {[["Two-Factor Authentication","SMS OTP enabled","#16A34A","ti-shield-check"],["Session Timeout","30 minutes","#D97706","ti-clock"],["Login Notifications","Email alerts enabled","#2563EB","ti-mail"]].map(([l,v,c,i])=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid #f1f5f9"}}>
            <div style={{width:36,height:36,borderRadius:9,background:c+"15",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ${i}`} style={{fontSize:16,color:c}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600,color:"#0F172A"}}>{l}</div>
              <div style={{fontSize:11,color:"#64748B"}}>{v}</div>
            </div>
            <button className="btn btn-ghost btn-sm">Configure</button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// ALERT MODAL
// ══════════════════════════════════════════════════════════════════════════════
function AlertModal({form,setForm,onClose,onSend}){
  return(
    <div className="adm-modal-overlay" onClick={onClose}>
      <div className="adm-modal" style={{maxWidth:480}} onClick={e=>e.stopPropagation()}>
        <div className="adm-modal-header" style={{background:"#FEF2F2",borderBottom:"1px solid #FECACA"}}>
          <i className="ti ti-bell-ringing" style={{fontSize:20,color:"#DC2626"}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:15,fontWeight:700,color:"#991B1B"}}>Send Emergency Alert</div>
            <div style={{fontSize:11,color:"#B91C1C"}}>This will notify all citizens in the selected area</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:20,color:"#94A3B8",cursor:"pointer"}}><i className="ti ti-x"/></button>
        </div>
        <div style={{padding:20}}>
          <div className="form-group">
            <label className="form-label">Alert Type</label>
            <select value={form.type} onChange={e=>setForm(p=>({...p,type:e.target.value}))} style={{width:"100%"}}>
              <option value="">Select type...</option>
              {ALERT_TYPES_ADMIN.map(a=><option key={a.id} value={a.id}>{a.label}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Message</label>
            <textarea value={form.message} onChange={e=>setForm(p=>({...p,message:e.target.value}))} placeholder="Alert message..." rows={3} style={{width:"100%"}}/>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={onSend} disabled={!form.type||!form.message} className="btn btn-danger" style={{flex:1,justifyContent:"center"}}>
              <i className="ti ti-send" style={{fontSize:14}}/>Send Alert Now
            </button>
            <button onClick={onClose} className="btn btn-ghost">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}
